import {
	CLEAR_AGREEMENT_FAIL,
	CLEAR_AGREEMENT_SUCCESS,
	GET_AGREEMENT_BY_ID_FAIL,
	GET_AGREEMENT_BY_ID_SUCCESS,
	GET_DEPOSIT_SCHEDULE_FAIL,
	GET_DEPOSIT_SCHEDULE_SUCCESS,
	GET_OPTION_DETAILS_FAIL,
	GET_OPTION_DETAILS_SUCCESS,
	GO_TO_STEP_FAIL,
	GO_TO_STEP_SUCCESS,
	LOAD_EXTERIOR_FAIL,
	LOAD_EXTERIOR_SUCCESS,
	LOAD_FLOORPLANS_FAIL,
	LOAD_FLOORPLANS_SUCCESS,
	NEXT_ACTIVE_STEP_FAIL,
	NEXT_ACTIVE_STEP_SUCCESS,
	PREVIOUS_ACTIVE_STEP_FAIL,
	PREVIOUS_ACTIVE_STEP_SUCCESS,
	REMOVE_SECOND_CLIENT_FAIL,
	REMOVE_SECOND_CLIENT_SUCCESS,
	RESET_AGREEMENT_FAIL,
	RESET_AGREEMENT_SUCCESS,
	SAVE_AGREEMENT_SUCCESS,
	SAVE_PERSISTED_DATA_FAIL,
	SAVE_PERSISTED_DATA_SUCCESS,
	SET_LOADING_FAIL,
	SET_LOADING_SUCCESS,
} from './types';

const initialState = {
	stepbar: 0,
	loading: false,
	clientInfo: {},
	productAvailability: {},
	options: {},
	exteriorImage: '',
	floorplansImages: '',
	agreementById: {},
	optionDetails: {},
	persistedData: {},
	depositSchedule: [],
};

export default function (state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case NEXT_ACTIVE_STEP_SUCCESS:
			return {
				...state,
				stepbar: state.stepbar !== 2 ? state.stepbar + payload : 2,
				loading: false,
			};
		case NEXT_ACTIVE_STEP_FAIL:
			return {
				...state,
				stepbar: payload,
				loading: false,
			};
		case PREVIOUS_ACTIVE_STEP_SUCCESS:
			return {
				...state,
				stepbar: state.stepbar !== 0 ? state.stepbar - payload : 0,
				loading: false,
			};
		case PREVIOUS_ACTIVE_STEP_FAIL:
			return {
				...state,
				stepbar: payload,
				loading: false,
			};
		case GO_TO_STEP_SUCCESS:
			return {
				...state,
				stepbar: payload,
				loading: false,
			};
		case GO_TO_STEP_FAIL:
			return {
				...state,
				stepbar: payload,
				loading: false,
			};
		case SAVE_AGREEMENT_SUCCESS:
			console.log('save payload', payload);
			return {
				...state,
				clientInfo: payload['clientInfo'],
				productAvailability: payload['productAvailability'],
				options: payload['options'],
				loading: false,
			};
		case LOAD_EXTERIOR_SUCCESS:
		case LOAD_EXTERIOR_FAIL:
			return {
				...state,
				exteriorImage: payload,
				loading: false,
			};
		case LOAD_FLOORPLANS_SUCCESS:
		case LOAD_FLOORPLANS_FAIL:
			return {
				...state,
				floorplansImages: payload,
				loading: false,
			};
		case CLEAR_AGREEMENT_SUCCESS:
		case CLEAR_AGREEMENT_FAIL:
			return {
				...state,
				stepbar: 0,
				productAvailability: {},
				options: {},
				exteriorImage: '',
				floorplansImages: '',
				loading: false,
			};
		case GET_AGREEMENT_BY_ID_SUCCESS:
		case GET_AGREEMENT_BY_ID_FAIL:
			return {
				...state,
				agreementById: payload,
				loading: false,
			};
		case REMOVE_SECOND_CLIENT_SUCCESS:
		case REMOVE_SECOND_CLIENT_FAIL:
			console.log('REMOVE_SECOND_CLIENT_SUCCESS');
			return {
				...state,
				agreementById: {
					...state?.agreementById,
					clientInfo: {
						...state.agreementById?.clientInfo,
						// secondClient: {},
					},
				},
				loading: false,
			};
		case GET_OPTION_DETAILS_SUCCESS:
		case GET_OPTION_DETAILS_FAIL:
			return {
				...state,
				optionDetails: payload,
				loading: false,
			};
		case RESET_AGREEMENT_SUCCESS:
		case RESET_AGREEMENT_FAIL:
			return {
				...state,
				stepbar: 0,
				loading: false,
				clientInfo: {},
				productAvailability: {},
				options: {},
				exteriorImage: '',
				floorplansImages: '',
				agreementById: {},
				optionDetails: {},
			};
		case SET_LOADING_SUCCESS:
		case SET_LOADING_FAIL:
			return {
				...state,
				loading: payload,
			};
		case SAVE_PERSISTED_DATA_SUCCESS:
		case SAVE_PERSISTED_DATA_FAIL:
			return {
				...state,
				persistedData: payload,
			};
		case GET_DEPOSIT_SCHEDULE_SUCCESS:
		case GET_DEPOSIT_SCHEDULE_FAIL:
			return {
				...state,
				depositSchedule: payload,
			};
		default:
			return state;
	}
}
